/*
const handleClick=(a,b)=>{a.classList.contains("expanded")?(a.classList.remove("expanded"),a.style.height="0px"):(a.classList.add("expanded"),a.style.height=`${b}px`)},accordionsInit=()=>{let a=[...document.querySelectorAll("[data-accordion-layout]")];a.map(b=>{let c=b.querySelector("[data-accordion-layout-header]"),a=b.querySelector("[data-accordion-layout-body]"),d=b.querySelector("input");a.classList.remove("css-only");let e=a.scrollHeight;a.style.height="0px",d.checked&&(a.classList.add("expanded"),a.style.height=`${e}px`),c.addEventListener("click",()=>handleClick(a,e)),window.addEventListener("resize",()=>{e=a.scrollHeight,a.classList.contains("expanded")&&(a.removeAttribute("style"),e=a.scrollHeight,a.style.height=`${e}px`)})})};document.addEventListener("DOMContentLoaded",()=>{accordionsInit()})
*/
const handleClick = (a, b, c, allAccordions) => {
    // Loop through all accordions and collapse others
    allAccordions.forEach(accordion => {
        const body = accordion.querySelector("[data-accordion-layout-body]");
        const header = accordion.querySelector("[data-accordion-layout-header]");

        // Collapse other accordions if they are open
        if (body !== a && body.classList.contains("expanded")) {
            body.classList.remove("expanded");
            body.style.height = "0px"; // Collapse other bodies
            header.classList.remove("open");
        }
    });

    // Toggle the current accordion
    if (a.classList.contains("expanded")) {
        a.classList.remove("expanded");
        a.style.height = "0px"; // Collapse the body
        c.classList.remove("open");
    } else {
        a.classList.add("expanded");
        a.style.height = `${b}px`; // Expand the body to the correct height
        c.classList.add("open");
    }
};

const accordionsInit = () => {
    const allAccordions = [...document.querySelectorAll("[data-accordion-layout]")]; // Get all accordion containers
    
    allAccordions.forEach(b => {
        const c = b.querySelector("[data-accordion-layout-header]"), // The accordion header
              a = b.querySelector("[data-accordion-layout-body]"), // The accordion body
              d = b.querySelector("input"); // Checkbox input
        
        a.classList.remove("css-only"); // Remove unnecessary CSS class

        // Initially set height to 0px (collapse the body)
        a.style.height = "0px";

        // Check if the accordion should be open on load (if data-accordion is "true")
        if (d && d.getAttribute("data-accordion") === "true") {
            // Get the correct scrollHeight after the page layout is calculated
            let e = a.scrollHeight;
            a.style.height = `${e}px`; // Set the correct height
            a.classList.add("expanded"); // Mark it as expanded
            c.classList.add("open"); // Mark the header as open
        }

        // Set up the click event listener on the accordion header
        c.addEventListener("click", () => {
            let e = a.scrollHeight; // Get the scrollHeight of the accordion body after layout update
            handleClick(a, e, c, allAccordions); // Call the toggle function with correct height

            // Get the height of the .product__info-container
            const productInfo = document.querySelector(".product__info-container");
            const productInfoHeight = productInfo ? parseInt(productInfo.style.height || 0) : 0; // Fallback to 0 if undefined

            // Get the height of the accordion content
            const contentHeight = parseInt(a.style.height || 0);

            // Combine the heights
            const combinedHeight = productInfoHeight + contentHeight;

            // Update the height of the product info container
             var height = $(window).height();   
                  // Update the height of the product info container
                if(productInfo) {
                       var elementHeight = productInfo.clientHeight;
                   productInfo.style.height = "max-content";
                //  console.log($('.product__info-container').height()+"===="+$(window).height());
                   if ($('.product__info-container').height() > $(window).height()) {
                      productInfo.style.marginTop = "50px"; 
                      var newHeight = $('.product__info-container').height() + 20;
                      productInfo.style.height = newHeight + "px"; 
                    }else{
                      productInfo.style.marginTop = "";
                     productInfo.style.height = height + "px";
                    }
                }

            //console.log("Updated product info height:", productInfo.style.height);
        });

        // Adjust accordion height on window resize
        window.addEventListener("resize", () => {
            let e = a.scrollHeight;
            if (a.classList.contains("expanded")) {
                a.removeAttribute("style");
                e = a.scrollHeight;
                a.style.height = `${e}px`;
            }
        });
    });


   setTimeout(() => {
        const allAccordions = [...document.querySelectorAll("[data-accordion-layout]")]; // Get all accordion containers

        var is_accordion_open = 0;
        allAccordions.forEach(b => {
            const c = b.querySelector("[data-accordion-layout-header]"), // The accordion header
                  d = b.querySelector("input"); // Checkbox input

            // Trigger the click event for accordions with data-accordion="true"
            if (d && d.getAttribute("data-accordion") === "true") {
                let a = b.querySelector("[data-accordion-layout-body]"); // The accordion body
                let e = a.scrollHeight;
                
                // Get the height of the .product__info-container
                const productInfo = document.querySelector(".product__info-container");
                const productInfoHeight = productInfo ? parseInt(productInfo.style.height || 0) : 0; // Fallback to 0 if undefined
               // console.log("productInfoHeight on load:", productInfoHeight);
                
                // Get the height of the accordion content
                const contentHeight = parseInt(a.style.height || 0);
              //  console.log("contentHeight on load:", contentHeight);

               

                // Expand the accordion without user click
                a.style.height = `max-content`; // Set the height of the body
                a.classList.add("expanded"); // Mark it as expanded
                c.classList.add("open"); // Mark the header as open
              is_accordion_open++;
               // Combine the heights
              
                 var height = $(window).height();   
                  // Update the height of the product info container
                if(productInfo) {
                       var elementHeight = productInfo.clientHeight;
                   productInfo.style.height = "max-content";
                    // console.log($('.product__info-container').height()+"===="+$(window).height());
                if ($('.product__info-container').height() > $(window).height()) {
                      productInfo.style.marginTop = "50px"; 
                      var newHeight = $('.product__info-container').height() + 20;
                      productInfo.style.height = newHeight + "px"; 
                    }else{
                      productInfo.style.marginTop = "";  productInfo.style.height = height + "px";
                    }
                }
              
            }
        });
    }, 1000); // Delay by 1 second to ensure the DOM is ready
};


// Initialize the accordions after the document is loaded
document.addEventListener("DOMContentLoaded", () => {
    accordionsInit();
});
